import React from 'react';

const BizEventSummarySkeleton = () => (
    <div className="flex flex-col gap-6 bg-blur-md bg-opacity-heavy border border-border-secondary rounded-3xl px-6 py-8">
      {/* Header skeleton */}
      <div className="flex flex-col gap-1">
        <div className="grid grid-cols-1 md:grid-cols-[1fr_auto] gap-4">
          <div className="h-8 w-48 bg-neutral-200 dark:bg-neutral-700 rounded animate-pulse" />
          <div className="h-10 w-36 bg-neutral-200 dark:bg-neutral-700 rounded animate-pulse hidden md:block" />
          <div className="h-4 w-64 bg-neutral-200 dark:bg-neutral-700 rounded animate-pulse md:col-span-2" />
        </div>
      </div>

      {/* Items skeleton */}
      <div className="flex flex-col">
        {Array(3).fill(0).map((_, index) => (
          <div key={index} className={`flex flex-row items-center p-4 border-border-secondary ${index === 0 ? 'border-y' : 'border-b'}`}>
            <div className="h-5 w-48 bg-neutral-200 dark:bg-neutral-700 rounded animate-pulse" />
            <div className="ml-auto hidden md:block">
              <div className="h-9 w-28 bg-neutral-200 dark:bg-neutral-700 rounded-2xl animate-pulse" />
            </div>
            <div className="ml-auto pl-2 md:hidden">
              <div className="w-6 h-6 bg-neutral-200 dark:bg-neutral-700 rounded animate-pulse" />
            </div>
          </div>
        ))}
      </div>
    </div>
);

export default BizEventSummarySkeleton;
